import { LitElement, html, svg } from 'lit';

export class IconArchway24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Buegang</title><path stroke="currentColor" stroke-width="1.5" d="M3 4v18a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7.5a4 4 0 0 1 8 0V22a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M1 15h9M14 15h9"></path><rect width="22" height="3" x="1" y="1" stroke="currentColor" stroke-width="1.5" rx="1"></rect></svg>`; }
}
if (!customElements.get('f-icon-archway24', IconArchway24)) {
  customElements.define('f-icon-archway24', IconArchway24);
}